import type { SVGProps } from 'react';

export const Bookmark = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m12 17.45-3.975 1.725c-.6.25-1.175.2-1.725-.15-.533-.367-.8-.867-.8-1.5V5.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h9.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v12.225c0 .633-.275 1.133-.825 1.5-.533.35-1.1.4-1.7.15L12 17.45Zm0-1.65 4.575 1.975c.1.033.192.025.275-.025.1-.067.15-.158.15-.275V5.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H7.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v12.175c0 .117.042.208.125.275.1.05.2.058.3.025L12 15.8ZM12 5H7h10-5Z" />
    </svg>
  );
};
